const SILENT_ENVS = new Set(['staging', 'production']);

/** Drop console.log on staging and production. Errors and warnings still print. */
export function silenceConsoleLog(env: string | undefined = import.meta.env.VITE_APP_ENV): void {
  if (!env || !SILENT_ENVS.has(env)) return;
  console.log = () => undefined;
}

silenceConsoleLog();
